import * as React from 'react'
import PropTypes from 'prop-types'
import { dataProps } from '@ds/react-utils'
import styles from './styles'

export const alignSelfValues = [
  'center',
  'start',
  'end',
  'self-start',
  'self-end',
  'flex-start',
  'flex-end',
] as const

export type AlignSelfValues = (typeof alignSelfValues)[number]

export interface FlexLayoutChildProps {
  /**
   * Overrides a flex item's align-items value. It aligns the item on the cross axis.
   */
  alignSelf?: AlignSelfValues
  /**
   * The `children` prop accepts arbitrary content items.
   */
  children: React.ReactNode
  /**
   * This allows a content item to fill available space.
   */
  grow?: boolean
}

export function FlexLayoutChild({
  alignSelf,
  children,
  grow,
  ...restProps
}: FlexLayoutChildProps) {
  const childStyles = [
    styles.default.child,
    grow && styles.grow.child,
    { alignSelf },
  ]

  return (
    <div {...dataProps(restProps)} css={childStyles}>
      {children}
    </div>
  )
}

FlexLayoutChild.propTypes = {
  alignSelf: PropTypes.oneOf(alignSelfValues),
  children: PropTypes.node.isRequired,
  grow: PropTypes.bool,
}

FlexLayoutChild.displayName = 'FlexLayout.Child'
